import {
  GET_NODE_EDGE,
  GET_NODE_EDGE_SUCCESS,
  GET_NODE_EDGE_ERROR,
  UPDATE_NODE_EDGE,
  UPDATE_NODE_EDGE_SUCCESS,
  UPDATE_NODE_EDGE_ERROR,
} from "../actions";

const INIT_STATE = {
  edgeId: null,
  nodeEdge: null,
  edgeDetailsError: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NODE_EDGE:
      return {
        ...state,
        loading: true,
        edgeId: action.payload.edgeId,
      };
    case GET_NODE_EDGE_SUCCESS:
      
      return {
        ...state,
        loading: false,
        edgeDetailsError: "",
        nodeEdge: action.payload.nodeEdge
      };
    case GET_NODE_EDGE_ERROR:
      return { ...state, loading: false, edgeDetailsError: action.payload ? action.payload.message : "" };
    case UPDATE_NODE_EDGE:
      return { ...state, loading: true, edgeDetailsError: "", record: action.payload.nodeEdge };
    case UPDATE_NODE_EDGE_SUCCESS:
      return { ...state, loading: false, edgeDetailsError: "", record: action.payload, isNewRecordPanelShown: false };
    case UPDATE_NODE_EDGE_ERROR:
      return { ...state, loading: false, edgeDetailsError: action.payload.message };
    default:
      return { ...state };
  }
};
